<template>
	<div id="benefits" class="benefits"
	:style="{
		backgroundImage: `url(${require(`@/assets/images/benefits/${benefitsBG}`)})`,
		}"

	>

		<div class="benefits_header">

			<SectionHeader subTitle="season ticket member benefits" topText="2023-2024" middleText=" MEMBERSHIP" bottomText="BENEFITS"  textColor="white" textAlign="center"/>
			<p class="header_content">
				We are excited to continue to provide our most sought-after benefits to all Season Ticket Members.
			</p>
		</div>

		<div class="benefits_section">
			<div  class="flip_card"  v-for="(benefit, i) in Benefits " :key="i">
				<img class="front-img"
    			  :src="require(`@/assets/images/benefits/${benefit.iconSrc}`)"
    			  alt=""
    			/>
				<h2 v-if="benefit.header" v-html="$sanitize(benefit.header)"></h2>
				<p v-if="benefit.text" v-html="$sanitize(benefit.text)">
   	   		    </p>
			</div>

		</div>


  </div>
</template>

<script>
import { useStore } from "vuex";
import { ref, reactive, toRefs, computed, onMounted } from "vue";
import SectionHeader from "@/components/SectionHeader";

export default {
  name: "Benefits",
  components: { SectionHeader },

  data() {
    return {};
  },
  setup() {
    const store = useStore();

    // State
    const state = reactive({
      	benefitsBG: computed(() =>
      	"bg-benefits.jpg"
      ),
    });

    const Benefits = [
	  {
		id: 7,
		header: ` 2024 Navy Federal Credit Union Stadium Series<sup>TM</sup>`,
        iconSrc: "arena.svg",
        text: `Priority access to purchase tickets to the 2024 Navy Federal Credit Union Stadium Series<sup>TM</sup> during a select pre-sale period.`,

	  },
	  {
        id: 0,
        header: `MEET THE <br/>PLAYERS EVENT`,
        iconSrc: "Layer_3.svg",
          text: "This exclusive Member event gives you the chance to meet some of your favorite players.",
      },
	  {
        id: 1,
        header: "EXCLUSIVE <br/> ISLANDERS Beanie",
        iconSrc: "ben-hat.svg",
          text: "A custom, stylish Isles Lab item designed just for you!",
      },
	  {
	    id: 2,
		// header: "MEMBER PRICING ON <br/>ISLES LAB PURCHASES",
	    header: "MEMBER PRICING AT <br/> ISLES LAB TEAM STORE & <br/> ON ISLESLAB.COM",
	    iconSrc: "Layer_6.svg",
	  	text: "Shop the best collections of Isles gear with 15% off your purchase.",
	  },
	  {
        id: 3,
        header: "PRIORITY PLAYOFF <br/> ACCESS",
        iconSrc: "Layer_4.svg",
          text: `The first chance and best pricing on New York Islanders playoff tickets.`,
      },
	  {
        id: 4,
        header: "SPECIAL OFFERS FROM <br/>ISLES PARTNERS",
        iconSrc: "Layer_1.svg",
          text: "Unique deals and offers from team partners that are just for Season Ticket Members.",
      },
	  {
        id: 5,
        header: "MEMBER PRICING FOR<br/> ADDITIONAL TICKETS",
        iconSrc: "Layer_5.svg",
          text: "Ability to purchase more game tickets at your preferred Member rate.",
      },
	  {
		id: 6,
		header: "$25 Isles Lab Credit",
		iconSrc: "Layer_2.svg",
		 text: "Enjoy $25 at Isles Lab for each seat in your Membership.",
	  },
	  {
        id: 6,
        header: "Ticket Exchange Program",
        iconSrc: "ben-exchange.svg",
          text: `Enjoy added flexibility to your Membership. <br/>Restrictions and blackouts apply. More details will follow ahead of schedule release.`,
      },





	  // {
      //   id: 5,
      //   header: "MEMBER PRICING AT <br/>ISLES LAB & ONLINE",
      //   iconSrc: "Layer_6.svg",
      //     text: "Shop the best collections of Isles gear with 15% off your purchase.",
      // },

    ];

    return { ...toRefs(state), store, Benefits };
  },
};
</script>


<style lang="scss" scoped>
// .remove_grid_class{
// 	display:none;
// }
.benefits {
  font-family: $font-main;
  background-size:cover;
  background-repeat:no-repeat;
  @include media-breakpoint-down(sm) {

  }
  // background: #00468b;
}
.benefits_header {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
  // text-align: center;
  padding: 50px 0px;

  //font-family: "AntaTrial-Regular";
  color: theme-var($--ch-theme-text);

  h2 {
    // text-transform:uppercase;
    letter-spacing: 0;
    line-height: 15px;
    text-align: center;
    font-weight: 900;
    color: theme-var($--ch-theme-secondary);
    margin-bottom: 30px;
    span {
      color: theme-var($--ch-theme-secondary);
      font-weight: 300;
    }
    @include media-breakpoint-down(sm) {
      font-size: 20px;
      line-height: 10px;
    }
  }
  .header_content{
	  width:40%;
	  font-family: "GeogrotesqueSharp-Md";
	  font-size: 18px;
	  color: theme-var($--ch-theme-on-primary);
	  letter-spacing: 0;
	  line-height: 20px;
	  text-align:left;
	  font-weight: 500;
	  margin-top: 30px;
	  text-align:center;
	  @include media-breakpoint-down(sm) {
	  	 width:80%;
		 // text-align:center;
	 }
  }
  .subtitle {
    font-size: 20px;
    color: #c19941;
    @include media-breakpoint-down(sm) {
      font-size: 16px;
    }
  }
  .title {
    font-size: 40px;
    color: #ffffff;
    @include media-breakpoint-down(sm) {
      font-size: 20px;
    }
  }
  p {
    font-size: 15.5px;
    color: #ffffff;
    letter-spacing: 0;
    text-align: center;
    line-height: 19px;
    font-weight: 400;
  }
  @include media-breakpoint-down(sm) {
    padding: 40px 15px;
  }
}
.benefits_section {
	display: flex;
 	flex-wrap: wrap;
 	justify-content: center;

  // display: grid;
  // grid-gap: 1px;
  // grid-template-columns: repeat(3, 0fr);
  align-items:  center;
  // align-content: center;
  // justify-content: center;
  // padding: 10px 60px 60px 60px;
	padding:0px 100px 100px 100px;
  @include media-breakpoint-down(sm) {
    // grid-template-columns: repeat(1, 0fr);
    padding:10px;
	align-items:  flex-start;
  }
   @media only screen and (min-width: 578px) and (max-width: 900px)  {
	   padding:10px;
	   // align-items:  flex-start;
   }
   @media only screen and (min-width: 901px) and (max-width: 1320px)  {
	  padding:10px;
 	}
  // @media only screen and (min-width: 900px) and (max-width: 1200px) {
  //
  // }
  .flip_card {
	  // flex:  0 0 25%;
	  flex: 0 0 calc(33.33% - 90px);
	  padding:20px 10px;
  	  margin: 10px;
	  background: rgba(0,0,0,0.54);
	  // height: 200px;
	  // width:330px;
	  display: flex;
	  flex-direction:column;
  	  // justify-content: center;
  	  align-items: center;
	   height: 250px;
	   position:relative;
      @include media-breakpoint-down(sm) {
		  flex: 0 0 calc(44% - 2px);
  		  padding: 10px 5px;
		   height: 280px;
      }
	  @media only screen and (min-width: 578px) and (max-width: 900px)  {
			  height: 260px;
			  flex: 0 0 calc(44% - 2px);
		 }
		 @media only screen and (min-width: 901px) and (max-width: 1320px)  {
			  flex: 0 0 calc(33.33% - 50px);
			  height: 280px;
		 }
	  .front-img{
		  height: 78px;
		  width:68px;
		   @include media-breakpoint-down(sm) {
			   height: 58px;
			   width:58px;
		   }
		   @media only screen and (min-width: 578px) and (max-width: 900px)  {
			   height: 58px;
			   width:58px;
		   }
	  }
	  h2 {
		text-transform:uppercase;
		font-family: "GeogrotesqueSharp-ExpBd";
		font-size: 18px;
		font-style: normal;
		font-weight: 700;
		line-height: 130%;
		letter-spacing: 0px;
		text-align: center;
		padding-top: 30px;
		color: theme-var($--ch-theme-on-primary);
		@include media-breakpoint-down(sm) {
		 	font-size: 14px;
			line-height: 16px;
		}
		 @media only screen and (min-width: 578px) and (max-width: 900px)  {
			 font-size: 15px;
		 }

      }
	  p{
		  text-align:center;

		  font-family: "GeogrotesqueSharp-Md";
		  font-size: 15.5px;
		  color: theme-var($--ch-theme-on-primary);
		  letter-spacing: 0;
		  line-height: 120%;
		  font-weight: 500;
		  // position:absolute;
		  // bottom: 10px;
		  padding:10px 20px 0px 20px;
		  @include media-breakpoint-down(sm) {
		  	 font-size: 12px;
			 line-height: 13px;

		 }
		 @media only screen and (min-width: 578px) and (max-width: 900px)  {
			 font-size: 12px;
 			line-height: 13px;
		}
	  }
  }
}

.benefits_section > div {
  padding: 5px;
  // background-color: #ccc;
}
//
@media only screen and (min-width: 578px) and (max-width: 900px) {
  .benefits_section {
    grid-template-columns: repeat(2, 0fr);
  }
}
</style>
